import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';

import EditRecipientTaxIdentifiersFormProvider from './context';
import { EditRecipientTaxIdentifiersBody } from './edit-tax-identifiers-body';
import { EditRecipientTaxIdentifiersFooter } from './edit-tax-identifiers-footer';
import messages from './messages';
import ModalPortal from '../../../../../../../components/modal-portal';
import { useFulfillmentPlanIdContext } from '../../../../../../../fulfillment-plans/context/fulfillment-plan-id-context-provider';
import { useEntitiesFulfillmentPlan } from '../../../../../../../hooks/entities/selectors/fulfillment-plans';
import { useSalesOrderIdContext } from '../../../../../../context/sales-order-id-context-provider';

/**
 * @param {object} props
 * @param {(isCancel?: boolean) => void} props.onClose - callback to execute logic when clicking on cancel or when data is saved
 * @returns {JSX.Element} - The render EditRecipientTaxIdentifiersModal
 */
export const EditRecipientTaxIdentifiersModal = ({ onClose }) => {
  const fulfillmentPlanId = useFulfillmentPlanIdContext();
  const salesOrderId = useSalesOrderIdContext();

  const fulfillmentPlan = useEntitiesFulfillmentPlan(fulfillmentPlanId);
  const { recipientTaxIdentifiers } = fulfillmentPlan;
  const isEditing = !!recipientTaxIdentifiers?.length;

  return (
    <ModalPortal onClose={onClose}>
      <Modal size='medium'>
        <ModalHeader>
          {isEditing ? (
            <FormattedMessage {...messages.editRecipientTaxIdentifierTitle} />
          ) : (
            <FormattedMessage {...messages.addRecipientTaxIdentifierTitle} />
          )}
        </ModalHeader>
        <EditRecipientTaxIdentifiersFormProvider
          fulfillmentPlanId={fulfillmentPlanId}
          initialTaxIdentifiers={recipientTaxIdentifiers}
          salesOrderId={salesOrderId}
        >
          <EditRecipientTaxIdentifiersBody />
          <EditRecipientTaxIdentifiersFooter onClose={onClose} />
        </EditRecipientTaxIdentifiersFormProvider>
      </Modal>
    </ModalPortal>
  );
};
